/**
 * The AI calls section's pages as one tab row: results, campaigns and the
 * automation that works the campaigns (ring R4).
 *
 * Links rather than state, so each page has its own address and the back
 * button moves between them.
 */
import { useNavigate } from "react-router-dom";
import { useT } from "../../../i18n/I18nProvider";
import { PillTabs } from "../../ui";

const AI_CALLS_TABS = ["results", "campaigns", "automation"] as const;
export type AiCallsTab = (typeof AI_CALLS_TABS)[number];

const PATHS: Record<AiCallsTab, string> = {
  results: "/ai-calls",
  campaigns: "/ai-calls/campaigns",
  automation: "/ai-calls/automation",
};

export function AiCallsTabs({ current }: { current: AiCallsTab }) {
  const t = useT();
  const navigate = useNavigate();
  const tabs = AI_CALLS_TABS.map((value) => ({ value, label: t(`aiCalls.tabs.${value}`) }));
  return (
    <PillTabs
      tabs={tabs}
      value={current}
      onChange={(next) => {
        if (next !== current) navigate(PATHS[next]);
      }}
      className="mb-4"
    />
  );
}
